// PrivacyPage.jsx
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import { fetchPrivacyPolicy } from "../../services/LegalService";
import "./PrivacyPage.css";

const PrivacyPage = () => {
  const [privacyData, setPrivacyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPrivacy = async () => {
      try {
        const data = await fetchPrivacyPolicy("en");
        setPrivacyData(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadPrivacy();
  }, []);

  if (loading) {
    return (
      <main className="privacy-page">
        <PageHeader
          title={"Privacy Policy"}
        />
        <div className="privacy-container">Loading...</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="privacy-page">
        <PageHeader
          title={"Privacy Policy"}
        />
        <div className="privacy-container">{error}</div>
      </main>
    );
  }

  return (
    <main className="privacy-page">
      <PageHeader
        title={"Privacy Policy"}
      />

      <div className="privacy-container">
        {/* INTRO - Dates + Introduction */}
        {/*{privacyData[0] && (*/}
        {/*  <div className="privacy-intro">*/}
        {/*    <h3>{privacyData[0].header}</h3>*/}
        {/*    {privacyData[0].steps.map((step, idx) => (*/}
        {/*      <p key={idx}>{step}</p>*/}
        {/*    ))}*/}
        {/*  </div>*/}
        {/*)}*/}

        {/* SEKCJE 1-12 */}
        {privacyData.slice(0, -1).map((section, idx) => (
          <section key={idx} className="privacy-section">
            <h2>{section.header}</h2>
            {section.steps.map((step, stepIdx) => (
              <p key={stepIdx} className="privacy-paragraph">
                {step}
              </p>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
};

export default PrivacyPage;
